<template>
  <section class="public-list-page-1 h5--page">
    <pcTitle v-if="isPC" @seeName="seeName"></pcTitle>
    <div class="serachOne">
      <el-button size="small" @click="searchQ = ''">清空</el-button>
      <el-input class="search-input" :clearable="true" size="small" v-model="searchQ" placeholder="输入标题或作者进行搜索">
        <el-button slot="append" icon="el-icon-search" @click="getPublicList(1)"></el-button>
      </el-input>
      <el-pagination
        small
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="totalNumber">
      </el-pagination>
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
    </div>
    <div style="listOne">
      <el-tabs v-model="activeName">
        <el-tab-pane label="文件" name="first">文件</el-tab-pane>
        <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
        <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
        <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
      </el-tabs>
    </div>
    <div class="public-title">
      <span class="title">标题</span>
      <span class="user-name">
        <span class="name">作者</span>
      </span>
      <!-- <span class="user-view">查看/回复</span> -->
      <!-- <span class="user-comment">
        <span class="name">最后回复</span>
      </span> -->
      <span class="action">操作</span>
    </div>
    <div class="main-wraper" ref="maimWraper">
      <div class="public-card" v-for="(item, index) in publicList" :key="index"  @click="goDetail(item)">
        <span class="title"><em class="status" :class="['status' + item.type]" v-if="selfActive == 1">[{{mapStatus[item.type]}}]</em><em class="area">[{{item.regionOne}}]</em>{{item.name}}</span>
        <span class="user-name">
          <span class="name">{{encryptName(item.userName)}}</span>
          <span class="time">{{item.creationTime}}</span>
        </span>
        <!-- <span class="user-view">{{item.seeTotal}}/{{item.commentNumber}}</span> -->
        <!-- <span class="user-comment">
          <span class="name">{{item.commentUserName || '--'}}</span>
          <span class="time">{{item.commentTime || '--'}}</span>
        </span> -->
        <span class="action">
          <span class="edit" @click.stop="goEdit(item)" v-if="selfActive == 1">编辑</span>
          <span class="view" @click.stop="goDetail(item)">查看</span>
        </span>
      </div>
    </div>
    <div class="no-result" v-if="!loadingFlag && !publicList.length">
      <i class="iconfont icon-kong"></i>
      <p>当前分类暂无帖子~</p>
    </div>
    <!-- <div class="index-bottom">
      <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备15023665号-3</a>
      |
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014179">浙公网安备 33011002014179号</a>
      | 电话：0571-82763607
    </div> -->
    <div>
    <div class="index-bottom-1">
      <div class="title-link">
        <div class="link-line">
          <span class="link-title">
            国家生态环境网站：
          </span>
          <a href="http://www.mee.gov.cn/" target="_blank">生态环境部</a>
        </div>
        <div class="link-line">
          <span class="link-title">
            省级生态环境网站：
          </span>
          <a href="http://sthjj.beijing.gov.cn/" target="_blank">北京</a>
          <a href="http://sthj.tj.gov.cn/" target="_blank">天津</a>
          <a href="https://sthj.sh.gov.cn/" target="_blank">上海</a>
          <a href="http://sthjj.cq.gov.cn/" target="_blank">重庆</a>
          <a href="http://hbepb.hebei.gov.cn/" target="_blank">河北</a>
          <a href="https://sthjt.shanxi.gov.cn/" target="_blank">山西</a>
          <a href="http://sthj.ln.gov.cn/" target="_blank">辽宁</a>
          <a href="http://sthjt.jl.gov.cn/" target="_blank">吉林</a>
          <a href="http://www.hljdep.gov.cn/" target="_blank">黑龙江</a>
          <a href="http://hbt.jiangsu.gov.cn/" target="_blank">江苏</a>
          <a href="http://sthjt.zj.gov.cn/" target="_blank">浙江</a>
          <a href="http://sthjt.ah.gov.cn/" target="_blank">安徽</a>
          <a href="http://sthjt.fujian.gov.cn/" target="_blank">福建</a>
          <a href="http://sthjt.jiangxi.gov.cn/" target="_blank">江西</a>
          <a href="http://sthj.shandong.gov.cn/" target="_blank">山东</a>
          <a href="http://sthjt.henan.gov.cn/" target="_blank">河南</a>
          <a href="http://sthjt.hubei.gov.cn/" target="_blank">湖北</a>
          <a href="http://sthjt.hunan.gov.cn/" target="_blank">湖南</a>
          <a href="http://gdee.gd.gov.cn/" target="_blank">广东</a>
          <a href="http://hnsthb.hainan.gov.cn/" target="_blank">海南</a>
          <a href="http://sthjt.sc.gov.cn/" target="_blank">四川</a>
          <a href="http://sthj.guizhou.gov.cn/" target="_blank">贵州</a>
          <a href="http://sthjt.yn.gov.cn/index.html" target="_blank">云南</a>
          <a href="http://sthjt.shaanxi.gov.cn/" target="_blank">陕西</a>
          <a href="http://sthj.gansu.gov.cn/" target="_blank">甘肃</a>
          <a href="http://sthjt.qinghai.gov.cn/" target="_blank">青海</a>
          <a href="http://ee.xizang.gov.cn/sysweb/portal/index.htl" target="_blank">西藏自治区</a>
          <a href="http://sthjt.nmg.gov.cn/" target="_blank">内蒙古自治区</a>
          <a href="http://sthjt.gxzf.gov.cn/" target="_blank">广西壮族自治区</a>
          <a href="http://sthjt.nx.gov.cn/" target="_blank">宁夏回族自治区</a>
          <a href="http://sthjt.xinjiang.gov.cn/" target="_blank">新疆维吾尔自治区</a>
          <a href="http://hbj.xjbt.gov.cn/" target="_blank">新疆生产建设兵团</a>
        </div>
        <div class="link-line">
          <span class="link-title">
            友情链接：
          </span>
          <a href="http://permit.mee.gov.cn/permitExt/defaults/default-index!getInformation.action" target="_blank">排污许可平台</a>
          <a href="http://114.251.10.92:8080/XYPT/" target="_blank">环评信用平台</a>
          <a href="https://cepc.lem.org.cn/#/login" target="_blank">自主验收平台</a>
          <a href="http://www.soilinfo.cn/map/index.aspx" target="_blank">土壤信息平台</a>
          <a href="http://www.ceett.org.cn/huanbao/infomation/xscx.html" target="_blank">环境工程服务</a>
          <a href="http://cloud.lem.org.cn/" target="_blank">环境质量模拟</a>
          <a href="https://yncx.mnr.gov.cn/" target="_blank">永久基本农田查询平台</a>
        </div>
        <div class="link-line-1">
          <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备15023665号-3</a>
          |
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014179">浙公网安备 33011002014179号</a>
          | 电话：0571-82763607
          <span style="color:#551A8B;padding:0px 0px 0px 400px;">总访问人次:{{name}}</span>
        </div>
      </div>
    </div>
    </div>
    <!-- <banner></banner> -->
    <splitNewFiles></splitNewFiles>
    <fileRank></fileRank>
  </section>
</template>

<script>
import api from '../../api/index'
import detect from '@/util/detect'
import pcTitle from '@/components/pcTitle'
// import banner from '@/components/public/banner'
import splitNewFiles from '@/components/public/splitNewFiles'
import fileRank from '@/components/public/fileRank'
export default {
  data () {
    return {
      searchQ: '',
      currentPage: 1,
      limit: 10,
      publicList: [],
      searchList: [{
        id: 0,
        name: '文件'
      }, {
        id: 1,
        name: '报告'
      }, {
        id: 2,
        name: '术语'
      }, {
        id: 3,
        name: '问答'
      }, {
        id: 4,
        name: '共享资料'
      }],
      searchTypeList: [{
        id: 0,
        name: '全国和地方'
      }, {
        id: 1,
        name: '全国'
      }, {
        id: 2,
        name: '地方'
      }],
      activeName: '文件',
      areaList: [],
      selfList: ['全部', '仅自己'],
      typeActive: 0,
      areaActive: 0,
      selfActive: 0,
      loadingFlag: true,
      totalNumber: 1,
      radio: 1,
      mapStatus: {
        0: '通过',
        1: '待审核',
        2: '拒绝'
      },
      isPC: detect.isPC,
      name: ''
    }
  },
  mounted () {
    // document.title = '环保公示'
    document.title = '生态环境公示网'
    api.getPublicClassList().then(res => {
      if (res.code === 200) {
        this.typeList = res.data
        this.typeList.unshift({
          id: 0,
          name: '不限'
        })
      }
    })
    api.getPublicAreaList().then(res => {
      if (res.code === 200) {
        this.areaList = res.data
        this.areaList.unshift({
          id: 0,
          name: '不限'
        })
      }
    })
    this.getPublicList()
    this.seeName()
  },
  activated () {
    // this.getPublicList()
  },
  methods: {
    seeName (name) {
      this.name = name
    },
    pageChange (page) {
      this.currentPage = page
      this.getPublicList(page)
    },
    showDownload () {
      this.$router.push('/h5download?type=public')
    },
    goEdit (item) {
      this.$router.push('public-edit?id=' + item.id)
    },
    goDetail (item) {
      if (item.type !== 0) {
        this.$message({
          message: '抱歉，审核失败、审核中的帖子，不支持在线查看~',
          type: 'warning'
        })
        return
      }
      // this.$router.push('/h5public-detail?id=' + item.id)
      if (item.category === '0') {
        window.open('/h5public-detail?id=' + item.id)
      } else if (item.category === '1') {
        window.open('/h5ehsPublic-detail?id=' + item.annId)
      }
      // window.open('/h5public-detail?id=' + 55)
    },
    handleCurrentChange (val) {
      this.getPublicList(val)
    },
    getPublicList (pageNo) {
      this.loadingFlag = true
      this.loading = this.$toast.loading()
      pageNo && (this.pageNo = pageNo)
      pageNo && (this.currentPage = pageNo)
      pageNo === 1 && (this.publicList = [])
      let tmpPromise = api.getPublicList
      let params = {
        pageNo: pageNo || this.pageNo || 1,
        pages: 20,
        classa: this.typeActive === 0 ? undefined : this.typeActive,
        region: this.areaActive === 0 ? undefined : this.areaActive,
        isUser: this.selfActive === 0 ? undefined : this.selfActive
      }
      if (this.searchQ) {
        tmpPromise = api.publicSearch
        params = {
          pageNo: pageNo || this.pageNo,
          pages: 20,
          classa: this.typeActive === 0 ? undefined : this.typeActive,
          region: this.areaActive === 0 ? undefined : this.areaActive,
          search: this.searchQ
        }
      }
      tmpPromise(params).then(res => {
        this.loading.hide()
        this.loadingFlag = false
        if (res.code === 200) {
          this.totalNumber = res.data.totalNumber
          this.publicList = res.data.list
        }
      })
    }
  },
  watch: {
    typeActive () {
      this.getPublicList(1)
    },
    areaActive () {
      this.getPublicList(1)
    },
    selfActive () {
      this.getPublicList(1)
    },
    searchQ () {
      this.getPublicList(1)
    }
  },
  components: {
    pcTitle,
    splitNewFiles,
    fileRank
    // banner
  }
}
</script>

<style lang="scss">
.public-list-page-1 {
  // display: flex;
  // flex-direction: column;
  min-width: 720px;
  .serachOne {
    padding: 40px 0 4px 0;
    background: #f4f5f6;
    display: flex;
    align-items: center;
    position: sticky;
    top: 135px;
    .wraper-left {
      transform: translateY(15%);
      flex: 1;
    }
    .wraper-right {
      flex: 0 0 120px;
      text-align: center;
    }
  }
  .listOne {
    margin: 0 0 0 100px;
    .el-tabs__nav-scroll {
      overflow: hidden;
      margin: 0 0 0 100px;
    }
  }
  .type-listA, .area-listA {
    padding: 0 12px;
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .tip {
      margin-right: 8px;
      margin-bottom: 8px;
      font-size: 18px;
    }
    .itemA {
      margin-right: 8px;
      margin-bottom: 8px;
      // line-height: 44px;
      width: 80px;
      height: 40px;
      background: #fff;
      font-size: 14px;
      // padding: 0px 4px;
      padding: 10px;
      border-radius: 4px;
      text-align: c;
      cursor: pointer;
      &:hover {
        color: #000;
      }
      &.active {
        color: #fff;
        background: #39b92e;
      }
    }
  }
  .type-action {
    padding: 0 12px;
    display: flex;
    position: sticky;
    justify-content: space-between;
    align-items: center;
    .do-public {
      background: #409EFF;
      color: #fff;
      width: 70px;
      border-radius: 4px;
      padding: 4px 6px;
      font-size: 16px;
      cursor: pointer;
    }
    .wraper-search {
      display: flex;
      padding: 0 4px 0 12px;
      border-left: 1px solid #efefef;
      margin-left: 12px;
      .search-input {
        margin-left: 12px;
      }
    }
    .flex-block {
      flex: 1;
    }
  }
  .public-title {
    transform: translateY(30%);
    border-top: 1px solid #efefef;
    background-color: #f4f5f6;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 6px 12px;
    margin-top: 10px;
    position: sticky;
    top: 310px;
    cursor: unset;
    .user-name, .user-view, .user-comment, .action {
      flex: 0 0 90px;
      display: flex;
      flex-direction: column;
      text-align: center;
      .time {
        font-size: 12px;
      }
    }
    .title {
      flex: 1 1 auto;
      font-size: 16px;
    }
  }
  .main-wraper {
    padding: 0 0 160px 0;
  }
  .index-bottom {
    background: #f2f6fc;
    text-align: center;
    font-size: 14px;
    padding: 12px;
    margin-top: 12px;
  }
  .index-bottom-1 {
    position: fixed;
    left: 115%;
    top: 85%;
    width: 2810px;
    margin-left: -155%;
    background: #f2f6fc;
    text-align: left;
    font-size: 14px;
    padding: 10px;
    margin-top: 12px;
    // width: 2310px;
    // margin-left: -135%;
    // background: #f2f6fc;
    // text-align: left;
    // font-size: 14px;
    // padding: 12px;
    // margin-top: 12px;
    .title-link {
      padding: 0 24px;
      padding-bottom: 8px;
      width: 700px;
      margin: 0 auto;
      font-size: 13px;
      .link-line {
        width: 1200px;
        .link-title {
          font-size: 16px;
          // color: #83889a;
          color: #000;
        }
        a {
          font-size: 14px;
          margin-right: 8px;
          color: #409EFF;
        }
      }
      .link-line-1 {
        width: 1200px;
        padding: 10px 0;
        a {
          font-size: 14px;
          margin-right: 8px;
          color: #551A8B;
        }
      }
    }
  }
  .public-card {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    cursor: pointer;
    &:nth-of-type(2n + 1) {
      background: #f9f9f9;
    }
    &:hover {
      background: #f4f5f6;
    }
    .user-name, .user-view, .user-comment, .action {
      flex: 0 0 90px;
      display: flex;
      flex-direction: column;
      text-align: center;
      .time {
        font-size: 12px;
      }
      .edit {
        color: #409EFF;
        &:hover {
          text-decoration: underline;
          font-weight: 500;
        }
      }
      .view {
        &:hover {
          text-decoration: underline;
          font-weight: 500;
        }
      }
    }
    .user-name .time {
      color: #409EFF;
    }
    .user-comment .time {
      color: #83889a;
    }
    .title {
      flex: 1 1 auto;
      font-size: 16px;
      .status0 {
        color: #39b92e
      }
      .status1 {
        color: #83889a;
      }
      .status2 {
        color: #F56C6C;
      }
      em {
        color: #409EFF;
        font-style: normal;
      }
    }
  }
  .no-result {
    i {
      font-size: 38px;
    }
    span {
      color: #409EFF;
      cursor: pointer;
    }
    margin-top: 24px;
    text-align: center;
    color: #83889a;
  }
  .public-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #efefef;
    // margin: 0 auto;
    padding: 6px 12px;
  }
  .home-banner {
    position: absolute;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 152px;
    transform: translateX(-100%);
    width: 300px;
    height: 56px;
    position: fixed;
  }
  .home-split-newfiles {
    position: fixed;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 212px;
    transform: translateX(-100%);
    width: 300px;
    height: 287px;
  }
  .file-rank-com {
    position: fixed;
    left: calc((100vw - 7.5rem) / 2 + 7.5rem + 10px);
    top: 152px;
    width: 300px;
    height: 287px;
    // height: 200px;
  }
}
</style>
